import React, { useState, useEffect } from 'react';
import {
  TFolderPicture,
  TPicture
} from '../../../types/cloudStorage/CloudFileList';
import { useRecoilState, useRecoilValue } from 'recoil';
import { folderListState } from '../../../GlobalState';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core';
import { COLOR_LIGHT_GRAY } from '../../../const/Const';
import FolderIcon from '@material-ui/icons/Folder';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

type TProps = {
  onSwitching: any;
};

export const FolderList: React.FC<TProps> = (props: TProps) => {
  const { onSwitching } = props;

  // フォルダーリスト(ファイルデータ含む)
  const folderList = useRecoilValue<TFolderPicture[]>(folderListState);

  const classes = useStyles();

  // サイズ調整
  const theme = useTheme();
  const isSmDownScreen = useMediaQuery(theme.breakpoints.up('sm'));
  const isMdDownScreen = useMediaQuery(theme.breakpoints.up('md'));

  return (
    <div className={classes.folderList} style={{}}>
      {folderList && folderList.length > 0 ? (
        <>
          {folderList.map((folder: TFolderPicture, index: number) => (
            <div
              className={classes.folder}
              style={{
                display: 'flex',
                flexDirection: isSmDownScreen ? 'row' : 'column',
                height: isSmDownScreen ? 80 : 'auto'
              }}
              onClick={() => onSwitching(folder.id, folder.name)}
              key={`AddField_${index}`}
            >
              <div
                className={classes.folderName}
                style={{ width: isSmDownScreen ? '70%' : '100%' }}
              >
                {/* フォルダアイコン */}
                <FolderIcon
                  className={classes.folderIcon}
                  style={{
                    fontSize: isSmDownScreen ? 'none' : '0.7em',
                    marginRight: 10
                  }}
                />
                {/* フォルダ名 */}
                <span
                  style={{
                    fontSize: isMdDownScreen ? '1em' : '0.6em',
                    alignItems: 'center',
                    marginRight: 5
                  }}
                >
                  {folder.name}
                </span>
              </div>
              <div
                className={classes.folderFileCount}
                style={{ width: isSmDownScreen ? '30%' : '100%' }}
              >
                {/* 写真の数 */}
                <span
                  style={{
                    fontSize: isMdDownScreen ? '1em' : '0.6em',
                    alignItems: 'center'
                  }}
                >
                  {folder.file_count}
                </span>
                {/* arrow > */}
                <ArrowForwardIosIcon
                  className={classes.arrowForwardIosIcon}
                  style={{ fontSize: isSmDownScreen ? 'medium' : 'small' }}
                />
              </div>
            </div>
          ))}
        </>
      ) : (
        <CircularProgress style={{ margin: '0 auto', marginTop: 280 }} />
      )}
    </div>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    folderList: {
      display: 'flex',
      flexWrap: 'wrap',
      height: 'auto'
    },
    folder: {
      display: 'flex',
      width: '100%',
      height: 60,
      borderTop: `solid 0.5px ${COLOR_LIGHT_GRAY}`
    },
    folderName: {
      display: 'flex',
      alignItems: 'center'
    },
    folderFileCount: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      marginLeft: 10
    },
    arrowForwardIosIcon: {
      color: COLOR_LIGHT_GRAY,
      margin: '0px 10px'
    },
    folderIcon: {
      color: COLOR_LIGHT_GRAY,
      margin: '0px 10px'
    }
  })
);
